<ng-template #itemLabel let-item>
    <mat-icon *ngIf="item.icon" [inline]="true" class="mibi-action-link__icon">{{ item.icon }}</mat-icon>
    <span class="mibi-action-link__label">{{ item.label }}</span>
</ng-template>

<div class="mibi-app-bar-bottom">
    <div class="mibi-app-bar-bottom__left">
        {{ title$ | async }}
    </div>
    <div class="mibi-app-bar-bottom__right">
        <ul class="mibi-action-list">
            <li *ngFor="let item of items$ | async" class="mibi-action-list__item">
                <ng-container [ngSwitch]="item.kind">

                    <mibi-upload-container *ngSwitchCase="'upload'"
                        [confirmMessage]="confirmMessageOf(item)"
                        (uploadFile)="onFileSelected(item.id, $event)">
                        <mibi-upload-action-item #uploadChild>
                            <a class="mibi-action-link">
                                <ng-container *ngTemplateOutlet="itemLabel; context: { $implicit: item }"></ng-container>
                            </a>
                        </mibi-upload-action-item>
                    </mibi-upload-container>

                    <ng-container *ngSwitchCase="'menu'">
                        <!-- Nothing to choose from: show the item, but inert. -->
                        <a *ngIf="menuEntries(item).length === 0"
                            class="mibi-action-link mibi-action-link__disabled">
                            <ng-container *ngTemplateOutlet="itemLabel; context: { $implicit: item }"></ng-container>
                        </a>

                        <!-- A single entry needs no menu. -->
                        <a *ngIf="menuEntries(item).length === 1"
                            class="mibi-action-link"
                            (click)="onSingleMenuEntrySelected(item)">
                            <ng-container *ngTemplateOutlet="itemLabel; context: { $implicit: item }"></ng-container>
                        </a>

                        <ng-container *ngIf="menuEntries(item).length > 1">
                            <button type="button" class="mibi-action-link" [matMenuTriggerFor]="entryMenu">
                                <ng-container *ngTemplateOutlet="itemLabel; context: { $implicit: item }"></ng-container>
                                <mat-icon [inline]="true" class="mibi-action-link__icon">arrow_drop_down</mat-icon>
                            </button>
                            <mat-menu #entryMenu="matMenu">
                                <a mat-menu-item *ngFor="let entry of menuEntries(item)"
                                    (click)="onMenuEntrySelected(item.id, entry.entryId)">
                                    {{ entry.label }}
                                </a>
                            </mat-menu>
                        </ng-container>
                    </ng-container>

                    <a *ngSwitchDefault class="mibi-action-link" (click)="onItemClicked(item.id)">
                        <ng-container *ngTemplateOutlet="itemLabel; context: { $implicit: item }"></ng-container>
                    </a>
                </ng-container>
            </li>
        </ul>
    </div>
</div>
